export const version = "9.3.1";
export const major = Number("9");
export const minor = Number("3");
export const patch = Number("1");
export const prerelease = undefined;
export default version;